"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNamedSettings = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const snackbar_context_1 = require("../../composite/snackbar/snackbar-context");
const snackbar_types_1 = require("../../composite/snackbar/snackbar-types");
const error_utils_1 = require("../../utils/error-utils");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const named_settings_api_1 = require("./named-settings-api");
function useNamedSettings(url, defaultTableNamedSettings = false) {
    const intl = (0, react_intl_1.useIntl)();
    const { showSnackbar } = (0, react_1.useContext)(snackbar_context_1.SnackbarContext);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const getNamedSettings = (0, event_callback_hook_1.useEventCallback)(async (tag) => {
        try {
            const response = await (0, named_settings_api_1.fetchSettingsByTag)(url, tag).response;
            let settings;
            try {
                const json = await response.json();
                settings = json;
            }
            catch {
                settings = [];
            }
            setLoading(false);
            return settings;
        }
        catch (err) {
            setLoading(false);
            if (err.name !== 'AbortError') {
                const errorDetail = (0, error_utils_1.getErrorMessage)(err);
                const message = intl.formatMessage({
                    id: 'EAS_NAMED_SETTINGS_MSG_LOAD_ERROR',
                    defaultMessage: 'Chyba načtení nastavení: {detail}',
                }, { detail: errorDetail });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                throw err;
            }
            return [];
        }
    });
    const saveNamedSettings = (0, event_callback_hook_1.useEventCallback)(async (settings) => {
        try {
            const result = await (0, named_settings_api_1.createSettings)(url, settings).json();
            setLoading(false);
            return result;
        }
        catch (err) {
            setLoading(false);
            if (err.name !== 'AbortError') {
                const errorDetail = (0, error_utils_1.getErrorMessage)(err);
                const message = intl.formatMessage({
                    id: 'EAS_NAMED_SETTINGS_MSG_SAVE_ERROR',
                    defaultMessage: 'Chyba uložení nastavení: {detail}',
                }, { detail: errorDetail });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                throw err;
            }
            throw err;
        }
    });
    const deleteNamedSettings = (0, event_callback_hook_1.useEventCallback)(async (id) => {
        try {
            await (0, named_settings_api_1.deleteSettings)(url, id).none();
            setLoading(false);
        }
        catch (err) {
            setLoading(false);
            if (err.name !== 'AbortError') {
                const errorDetail = (0, error_utils_1.getErrorMessage)(err);
                const message = intl.formatMessage({
                    id: 'EAS_NAMED_SETTINGS_MSG_CLEAR_ERROR',
                    defaultMessage: 'Chyba mazání nastavení: {detail}',
                }, { detail: errorDetail });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                throw err;
            }
        }
    });
    const context = (0, react_1.useMemo)(() => ({
        getNamedSettings,
        saveNamedSettings,
        deleteNamedSettings,
        defaultTableNamedSettings,
    }), [
        getNamedSettings,
        saveNamedSettings,
        deleteNamedSettings,
        defaultTableNamedSettings,
    ]);
    return { context, loading };
}
exports.useNamedSettings = useNamedSettings;
//# sourceMappingURL=named-settings-hook.js.map